import { makeAsyncCall } from 'src/utils';
import { BACKEND_URL } from 'src/constants';

export const StorageService = {
  uploadFile: (file: File) => {
    return new Promise<string>((resolve, reject) => {
      makeAsyncCall({
        url: `${BACKEND_URL}storage/upload-url`,
        method: 'GET',
      }).then(
        urlRes => {
          let formData = new FormData();
          for (let name in urlRes.body.data.inputs) {
            formData.append(name, urlRes.body.data.inputs[name]);
          }
          formData.append('file', file);

          makeAsyncCall({
            url: urlRes.body.data.attributes.action,
            method: urlRes.body.data.attributes.method,
            body: formData,
            headers: {
              'Content-Type': null,
            },
          }).then(
            fileUploadRes => {
              const parser = new DOMParser();
              const xml = parser.parseFromString(fileUploadRes.body, 'text/xml');
              const responseText =
                xml.getElementsByTagName('Key')[0].childNodes[0].nodeValue || '';
              const uploadPath = responseText.replace('survey_data/', '');
              resolve(uploadPath);
            },
            error => reject(error)
          );
        },
        error => reject(error)
      );
    });
  },
};
